<div class="container" *ngIf="quoteArray$ | async as quoteArray else loading">
    <div class="row">
        <div class="col-md-3">
            <div (click)="navigateToDetails()" class="details-link">
                <i class="material-icons back-icon">keyboard_arrow_left</i><span class="back-text">{{ "quoteTracking.backQuoteStatus" | cxTranslate }} </span>
            </div>
            
        </div>
        <div class="col-md-6 middle-text">
            <div>
                {{ "quoteTracking.mergeThreeQuotes" | cxTranslate }}
            </div>
            <div>
                {{ "quoteTracking.goBackAcceptQuote" | cxTranslate }} 
            </div>
        </div>
        <div class="col-md-3">
    
        </div>
    </div>

    <div class="row">
        <div class="col-md-10 align-center">
            <div class="row">
                <div class="col-md-8">
                    <div class="row merge-quote-row">
                        <div *ngFor='let item of quoteArray; let i = index' class="col-md-4">
                            <vs-merge-quote-cards [vsQuote]='quoteArray[i]' [index]='i' (deleteCard)="deleteCard($event)" (updateActiveCard)='updateActiveCard($event)' [active]="active"></vs-merge-quote-cards>
                        </div>
                        <div *ngFor="let item of getQuoteCards();let i = index" class="col-md-4">
                            <vs-merge-quote-cards [vsQuote]='quoteArray[maxLength - (quoteArray.length-1)]' [index]='quoteArray.length-1+i' (deleteCard)="deleteCard($event)" (updateActiveCard)='updateActiveCard($event)' [active]="active"></vs-merge-quote-cards>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-4">
                    <div class="vs-card">   
                        <div class="row">
                            <div class="col-2">
                                <div class="vs-card-logo">
                                    <i class="material-icons vs-card-logo-font">playlist_add_check</i>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="bold quote-title">{{ "quoteTracking.mergeQuotes" | cxTranslate }}</div>
                                <div class="quote-title">
                                    {{ "quoteTracking.proceedToCheckout" | cxTranslate }}
                                </div>
                            </div>
                        </div>
                        <div class="info-text">
                            {{ "quoteTracking.acceptSelectedQuotes" | cxTranslate }}
                        </div>
                        <div>
                            <button class="vs-primary-btn" (click)="openMergeModal()" [disabled]='totalMergeItemChecked == 0'>
                                <i class="material-icons merge-icon">call_merge</i> {{ "quoteTracking.acceptAndCheckout" | cxTranslate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>      
        </div>
        
    </div>
    
    <div class="row">
        <div class="col-md-10 align-center">
            <div *ngFor="let quote of quoteArray">
                <vs-merge-quote-products-list [quote]='quote' [dateObject]="dateObject" (getQuoteLineDetails)='getQuoteLineDetails($event)'></vs-merge-quote-products-list>
            </div>
        </div>
    </div>
</div>
<ng-template #loading>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
</ng-template>
